export default "__VITE_ASSET__Cbx1YACv__"